import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum OrganizationBillingInvoicesColumn {
    DATE = "date",
    STATUS = "status",
    AMOUNT = "amount",
    DOWNLOAD = "download",
}

const DateColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingInvoicesColumn.DATE),
});

const StatusColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingInvoicesColumn.STATUS),
});

const AmountColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingInvoicesColumn.AMOUNT),
});

const DownloadColumnSchema = ColumnSchema.extend({
    id: z.literal(OrganizationBillingInvoicesColumn.DOWNLOAD),
});

export const OrganizationBillingInvoicesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ORGANIZATION_BILLING_INVOICES),
    columns: z.array(
        z.discriminatedUnion("id", [
            DateColumnSchema,
            StatusColumnSchema,
            AmountColumnSchema,
            DownloadColumnSchema,
        ]),
    ),
});

export type OrganizationBillingInvoicesView = z.infer<
    typeof OrganizationBillingInvoicesViewSchema
>;
